import { ButtonProps, Palette, Theme, buttonClasses } from '@mui/material';

type ColorKey = keyof Palette | 'inherit';

const COLORS: ColorKey[] = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
  'accent',
  'inherit',
];

const button = (theme: Theme) => {
  const rootStyles = (ownerState: ButtonProps) => {
    const containedVariant = ownerState.variant === 'contained';
    const outlinedVariant = ownerState.variant === 'outlined';
    const linkVariant = ownerState.variant === 'link';

    const smallSize = ownerState.size === 'small';
    const mediumSize = ownerState.size === 'medium';

    const defaultStyle = {
      ...(containedVariant && {
        backgroundColor: theme.palette.primary.dark,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
        },
      }),

      ...(outlinedVariant && {
        color: theme.palette.primary.dark,
        border: `1px solid ${theme.palette.custom.lightGrey}`,
        '&:hover': {
          color: theme.palette.custom.text,
          border: `1px solid ${theme.palette.custom.text}`,
          backgroundColor: 'transparent',
        },
      }),

      ...(linkVariant && {
        color: theme.palette.primary.dark,
        '&:hover': {
          color: theme.palette.primary.main,
          textDecoration: 'underline',
        },
      }),
    };

    const disabledStyle = {
      [`&.${buttonClasses.disabled}`]: {
        ...(containedVariant && {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.custom.lightGrey,
        }),
        ...(outlinedVariant && {
          color: theme.palette.custom.lightGrey,
          border: `1px solid ${theme.palette.custom.lightGrey}`,
          backgroundColor: 'transparent',
        }),
        ...(linkVariant && {
          color: theme.palette.custom.lightGrey,
        }),
      },
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color &&
        color !== 'inherit' && {
          ...(containedVariant && {
            backgroundColor: theme.palette[color].dark,
            '&:hover': {
              backgroundColor: theme.palette[color].main,
            },
          }),
        }),
    }));

    const size = {
      ...(mediumSize && {
        height: 44,
        padding: '12px 16px',
      }),

      ...(smallSize && {
        height: 32,
        padding: '6px 16px',
      }),
    };

    return [defaultStyle, ...colorStyle, disabledStyle, size];
  };

  return {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ButtonProps }) =>
          rootStyles(ownerState),
      },
    },
  };
};

export default button;
